import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { getStatusIconName } from 'utils/status'
import KanBoIcon from 'components/KanBoIcon'
import Content from '../../Content'
import ElementContentIcon from '../../ContentIcon'
import Scrollbars from 'components/Scrollbars'
import {
  ContentHeader,
  ContentTitle,
} from 'components/Content'
import {
  ToggleModal
} from 'components/Modal'
import Line from './Line'
import CardStatusAction from 'components/CardActions/Status'
import classes from './Status.module.scss'
import { withBoardPermission } from 'dataProviders/Board'
import { useColor } from 'utils/colors'

export class Status extends React.Component {
  static propTypes = {
    permission: PropTypes.object.isRequired,

    cardContext: PropTypes.object.isRequired,

    isArchived: PropTypes.bool.isRequired,
    cardStatuses: PropTypes.array.isRequired,
    status: PropTypes.object.isRequired,

    statusColor: PropTypes.string.isRequired,

    requestChangeCardStatus: PropTypes.func.isRequired
  }

  handleToggleModalRef = (ref) => {
    this.toggleModalRef = ref
  }

  handleStatusClick = ({ id }) => {
    const {
      cardContext,
      status,
      requestChangeCardStatus
    } = this.props

    if (id !== status.id) {
      requestChangeCardStatus({
        cardId: cardContext.id,
        cardStatusId: id
      })
    }

    this.toggleModalRef.close()
  }

  renderStatusName = () => {
    const {
      status,
      statusColor,
    } = this.props

    return (
      <ContentHeader>
        <ElementContentIcon>
          {!status &&
            <KanBoIcon spin name='kanbo-16-loading' />
          }
          {status &&
            <KanBoIcon name='kanbo-24-status' />
          }
        </ElementContentIcon>
        <ContentTitle
          className={classes.label}
        >
          <FormattedMessage id='CARD_STATUS' />
        </ContentTitle>
        {status &&
          <ContentTitle
            className={classes.name}
          >
            <KanBoIcon
              name={getStatusIconName(status.role)}
              className={classes.statusIcon}
              style={{
                color: statusColor,
              }}
            />
            {status.name}
          </ContentTitle>
        }
      </ContentHeader>
    )
  }

  renderStatusSelection = () => {
    const {
      cardStatuses,
      status
    } = this.props

    return (
      <ToggleModal
        backdrop
        ref={this.handleToggleModalRef}
        attachment='top left'
        targetAttachment='top left'
        constraints={[
          {
            to: 'window',
            pin: true
          }
        ]}
      >
        {this.renderStatusName()}
        <Scrollbars
          className={classes.modal}
        >
          <CardStatusAction
            cardStatuses={cardStatuses}
            status={status}
            onStatusClick={this.handleStatusClick}
          />
        </Scrollbars>
      </ToggleModal>
    )
  }

  render () {
    const {
      permission,
      isArchived,
      status,
    } = this.props

    return (
      <Content>
        {(!isArchived && permission.member)
          ? this.renderStatusSelection()
          : this.renderStatusName()
        }
        {status &&
          <Line {...this.props} />
        }
      </Content>
    )
  }
}

const StatusWithColor = React.forwardRef((props, ref) => {
  const statusColor = useColor(props.status.color)

  return (
    <Status
      ref={ref}
      statusColor={statusColor}
      {...props}
    />
  )
})

export default withBoardPermission(StatusWithColor)
